import DisputeTransactionPage from "components/pages/DisputeTransactionPage";
import DisputeTransactionView from "components/pages/DisputeTransactionPage/components/DisputeTransactionView";

/**
 * @function DisputeTransactionStartPage
 * @param {OBJECT} data - Object to modify the data view.
 * @param {OBJECT} ui - Object to modify the ui of the view.
 * @return {React.Component}
 * @exported true
 * @description This page is a step in the dispute transactions workflow.
 * @example
 * <DisputeTransactionStartPage data={ data } ui={ ui } />
 */
export default function DisputeTransactionStartPage(props) {
    const data = props.data ? { data: props.data } : {};
    const ui = props.ui ? { ui: props.ui } : {};
    
    return (
        <DisputeTransactionPage 
        view={ <DisputeTransactionView { ...data } { ...ui } /> }
        />
    );
}